export default __webpack_public_path__ + "static/media/4.bfe84b42.png";